module.exports = __webpack_public_path__ + "static/media/user-icon.f0922a65.svg";